import { manufactureConstants } from "../../constants";

const defaultState = {
  items: null,
  loading: false,
  fetched: false,
  error: null
};

export const materialsReducer = (state = defaultState, action) => {
  switch (action.type) {
    case manufactureConstants.GET_SERIAL_SPECIF_REQUEST:
      return {
        ...state,
        loading: true,
        fetched: false,
        error: null
      };
    case manufactureConstants.GET_SERIAL_SPECIF_SUCCESS:
      return {
        ...state,
        items: normalData(action.response),
        loading: false,
        fetched: true
      };
    case manufactureConstants.GET_SERIAL_SPECIF_FAILURE:
      return {
        ...state,
        loading: false,
        fetched: false,
        error: action.error
      };
    default:
      return state;
  }
};

function normalData(arr) {
  if (!Array.isArray(arr)) return [];

 return arr.map((elem, index) => {
  // Определяем источник unit
  let unitName = '-';

  if (elem.nomenclature?.unit) {
    // Случай: материал из номенклатуры
    unitName = elem.nomenclature.unit.nameUnit || elem.nomenclature.unit.fullNameUnit || '-';
  } else if (elem.product?.nomenclature?.unit) {
    // Случай: изделие → его номенклатура → unit
    unitName = elem.product.nomenclature.unit.nameUnit || elem.product.nomenclature.unit.fullNameUnit || '-';
  }

  return {
    ...elem,
    index: index + 1,
    nomenclature: elem.nomenclature?.nameNomenclature || (elem.product?.nomenclature?.nameNomenclature) || '—',
    characteristic: elem.characteristic?.name || '—',
    unit: unitName,
    serialNumber: elem.product?.serialNumber || null,
  };
});
}